export default __webpack_public_path__ + "/images/game_controller.png";